import React from 'react';

import { OfferingMenuFeatures } from '../types';

export const OfferingMenuFeaturesContext = React.createContext<OfferingMenuFeatures>({
  isRetail: false,
  bottleDeposits: false,
  hasCatalogSource: false,
  bundleItems: false,
  posIntegration: false,
  inventoryManagement: false,
  overTheCounter: false,
  extendedUsageInstructions: false,
  categoryImages: false,
  hasPickerEnabled: false,
  hasReturnPoliciesEnabled: false,
  hasWoltPlusSpecialsEnabled: false,
  supportWeightedItems: false,
  mandatoryWarnings: false,
  overTheCounterHyperlinkAllowed: false,
  restockingRulesEnabled: false,
  externalInfoHyperlinkAllowed: false,
  externalHelpCenterLinkEnabled: false,
});

export const useOfferingMenuFeaturesContext = () => React.useContext(OfferingMenuFeaturesContext);
